import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import ContentBlock from "../Content/content";
import TextField from "./Inputs/TextField";
import {Link} from "gatsby";
import TextArea from "./Inputs/TextArea";
import { DatePicker } from 'react-nice-dates'
import TimePicker from 'rc-time-picker';
import 'react-nice-dates/build/style.css'
import 'rc-time-picker/assets/index.css';
import Recaptcha from "./Inputs/Recaptcha"; 
import { postFormData } from "./api/Api";
import { ScrollToTop, SendMail, FormValidation } from "../Common/utils";
import _ from "lodash";
import moment from 'moment';
import "./Form.scss";
const PropertyContact = (props) => {
    const recaptchaRef = useRef();
    const initFormState = {
        formname: "Enquiry Form",
        fname: '',
        lname: '',
        email: '',
        telephone: '',
        preferredDate: new Date(),
        preferredTime: moment().hour(10).minute(0).format("h:mm a"),
    }
    const validationFields = ['fname', 'lname', 'telephone', 'email'];
    const [formState, setFormState] = useState(initFormState);
    const [propertytype, setPropertytype] = useState('Sell');
    const [errors, setErrors] = useState({});
    const [errorFlag, setErrorFlag] = useState(false);
    const [showthankyou, setThankyou] = useState(false);
    const [btnProcess, setBtnProcess] = useState(false);
    const [date, setDate] = useState(new Date())
    const [time, setTime] = useState(moment().hour(10).minute(0))

    const myRef = React.createRef();
    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        });
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        var validation = FormValidation(formState, validationFields);
        if (validation.status) {
            setErrorFlag(false)
            setErrors(validation.errors)
            const token = await recaptchaRef.current.executeAsync();
            if (token) {
                setBtnProcess(true)
                var postData = _.cloneDeep(formState)
                postData['extra'] = formState;
                recaptchaRef.current.reset();
                postFormData(postData).then(async apiRes => {
                    setThankyou(true)
                    setFormState(initFormState)
                    setBtnProcess(false);
                    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    // scrollTop();
                    setTimeout(() => {
                        setThankyou(false)
                    }, 2000)
                    // GTM tracking event 
                    // gtmEvent({ formType: 'Property Valuation', formName: 'Home Visit Valuation' })
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                    event: "formSubmit",
                    formType: "form-contact",
                    formId: "form-contact",
                    formName: "Enquiry Form",
                    formLabel: "Enquiry Form",
                    })
                    // lets send mail
                    postData['email_temp_user'] = 'propertycontact_user';
                    postData['email_temp_admin'] = 'propertycontact_admin';
                    postData['email_subject_user'] = 'General Enquiry';
                    postData['email_subject_admin'] = 'From Web: General Enquiry';
                    postData["property_address"]=props.propertyAddress;
                    postData['g-recaptcha-response'] = token;
                    await SendMail(postData);
                });
            }
        } else {
            setErrors(validation.errors)
            setErrorFlag(true)
            myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
            // scrollTop();
        }
    }

    const scrollTop = () => {
        ScrollToTop(document.getElementById('form-section'), 100)
    }
    const errClass = (field) => {
        if (errors[field]) {
            return 'field-error';
        }
        return ''
    }
    return (
        <React.Fragment>
            <section className='form-section contact-modal-form prop-contact' id="form-section" >
                <Container>
                    <Row>
                            <Col md={12}>
                                <div className='mortgage-wrapper' ref={myRef}>
                                    <div className='form-wrapper'>
                                        {showthankyou && <div className="alert alert-success">
                                            Thank you for your interest. A member of our team will contact you shortly.
                                        </div>}
                                        {
                                            errorFlag &&
                                            <div className="alert alert-danger alert-error">Highlighted fields are required | invalid</div>
                                        }

                                        <div className='form-inputs'>
                                        <Row>
                                            <Col md={6}>
                                            <TextField
                                                label="First Name"
                                                name={`fname`}
                                                placeholder=""
                                                onChange={handleChange}
                                                value={formState[`fname`]}
                                                className={errClass(`fname`)}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                label="Last Name"
                                                name={`lname`}
                                                placeholder=""
                                                onChange={handleChange}
                                                value={formState[`lname`]}
                                                className={errClass(`lname`)}
                                            />
                                            </Col>
                                            </Row>
                                            <Row>
                                            <Col md={6}>
                                            <TextField
                                                label="Email Address"
                                                name={`email`}
                                                placeholder=""
                                                onChange={handleChange}
                                                className={errClass(`email`)}
                                                value={formState[`email`]}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                type="number"
                                                label="Telephone"
                                                name={`telephone`}
                                                placeholder=""
                                                onChange={handleChange}
                                                className={errClass(`telephone`)}
                                                value={formState[`telephone`]}
                                            />
                                            </Col>
                                            
                                            </Row>
                                        {/* <TextArea
                                            label="Message"
                                            rows={5}
                                            name="message"
                                            placeholder="Enter your message"
                                            onChange={handleChange}
                                            className="textarea"
                                            value={formState[`message`]}
                                        /> */}
                                        </div>
                                        
                                        <Recaptcha recaptchaRef={recaptchaRef} />
                                        <Button type="submit"
                                            disabled={btnProcess}
                                            onClick={(event) => { handleSubmit(event) }}
                                            className='btn outline width-100'
                                        >Contact</Button>
                                        <div className='form-footer-text book-viewing'>
                                            By clicking Submit, you agree to our <Link to="/terms-of-use/">Terms & Conditions</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    
                </Container>
            </section>
        </React.Fragment >
    )

}
export default PropertyContact;
